import { render, staticRenderFns } from "./hsc-eald.vue?vue&type=template&id=56b52a71&"
import script from "./hsc-eald.vue?vue&type=script&lang=js&"
export * from "./hsc-eald.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports